import React, { useState, useEffect } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { Print as PrintIcon, Close as CloseIcon } from "@mui/icons-material";
import axios from "axios";
import config from "./global/config";

const PrintFacture = ({
  factureData,
  onClose,
  companyInfo = {
    name: "Your Company Name",
    address: "123, Avenue Mohammed V, Casablanca",
    phone: "+212 5XX-XXXXXX",
    email: "contact@company.com",
  },
}) => {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFactureDetails = async () => {
      try {
        const api = axios.create({
          baseURL: config.apiUrl,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const response = await api.get(
          `details_factures.php?id_facture=${factureData.id_facture}`
        );
        setDetails(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching facture details:", error);
      } finally {
        setLoading(false);
      }
    };

    if (factureData?.id_facture) {
      fetchFactureDetails();
    }
  }, [factureData]);

  const handlePrint = async () => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Please allow pop-ups to print the invoice.");
      return;
    }

    const formatDate = (dateString) => {
      return new Date(dateString).toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    };

    const totalAmount = details.reduce(
      (sum, detail) => sum + (parseFloat(detail.montant_total) || 0),
      0
    );

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Facture - ${factureData.numero_facture}</title>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap">
          <style>
            @page {
              size: A4;
              margin: 20mm;
            }
            
            * {
              box-sizing: border-box;
              margin: 0;
              padding: 0;
            }

            body {
              font-family: 'Open Sans', Arial, sans-serif;
              line-height: 1.6;
              color: #2c3e50;
              background: #fff;
              font-size: 12px;
            }

            .page {
              position: relative;
              width: 210mm;
              min-height: 297mm;
              padding: 20mm;
              margin: 0 auto;
              background: white;
            }

            .company-header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              margin-bottom: 20px;
            }

            .company-info {
              flex: 1;
              display: flex;
              gap: 15px;
            }

            .company-logo {
              background: #1a237e;
              width: 48px;
              height: 48px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: white;
              font-weight: bold;
              border-radius: 4px;
              flex-shrink: 0;
            }

            .company-details {
              font-size: 10px;
              color: #546e7a;
              line-height: 1.5;
            }

            .invoice-title {
              color: #1565c0;
              font-size: 18px;
              font-weight: 700;
              margin: 15px 0;
              text-align: center;
              letter-spacing: 0.5px;
            }

            .invoice-metadata {
              font-size: 10px;
              color: #546e7a;
              margin-bottom: 20px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }

            .section-title {
              font-size: 14px;
              font-weight: 600;
              color: #37474f;
              margin: 25px 0 15px;
              text-transform: uppercase;
            }

            .invoice-info-grid {
              display: flex;
              justify-content: space-between;
              margin-bottom: 15px;
              gap: 20px;
              background-color: #f8f9fa;
              padding: 10px;
              border-radius: 4px;
            }

            .info-column {
              flex: 1;
            }

            .info-group {
              margin-bottom: 0;
            }

            .info-label {
              font-size: 9px;
              text-transform: uppercase;
              color: #546e7a;
              font-weight: 600;
              margin-bottom: 2px;
            }

            .info-value {
              color: #2c3e50;
              font-size: 11px;
              line-height: 1.3;
            }

            .client-name {
              font-weight: 600;
              font-size: 12px;
              color: #1a237e;
              margin-bottom: 2px;
            }

            .info-item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 4px;
              border-bottom: 1px solid #e0e0e0;
              padding: 4px 0;
            }

            .info-item:last-child {
              border-bottom: none;
              margin-bottom: 0;
            }

            .info-item .info-label {
              margin-bottom: 0;
            }

            .info-item .info-value {
              font-weight: 600;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 30px;
            }

            th {
              background-color: #f5f5f5;
              color: #37474f;
              font-weight: 600;
              text-align: left;
              padding: 12px;
              border: 1px solid #e0e0e0;
              font-size: 11px;
            }

            td {
              padding: 10px 12px;
              border: 1px solid #e0e0e0;
              color: #455a64;
              font-size: 11px;
            }

            .amount-cell {
              text-align: right;
              font-family: 'Courier New', monospace;
            }

            .total-row {
              font-weight: 600;
              background-color: #fafafa;
            }

            .total-row td {
              border-top: 2px solid #37474f;
            }

            .signature-section {
              display: flex;
              justify-content: space-between;
              margin-top: 60px;
              margin-bottom: 80px;
            }

            .signature-box {
              width: 45%;
            }

            .signature-line {
              border-bottom: 1px solid #90a4ae;
              margin-bottom: 8px;
              padding-top: 40px;
            }

            .signature-title {
              text-align: center;
              color: #546e7a;
              font-size: 11px;
              font-weight: 600;
            }

            .footer {
              position: absolute;
              bottom: 20mm;
              left: 20mm;
              right: 20mm;
              text-align: center;
              border-top: 1px solid #e0e0e0;
              padding-top: 15px;
            }

            .footer-text {
              color: #78909c;
              font-size: 10px;
              line-height: 1.6;
            }

            @media print {
              body {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="page">
            <!-- Company Header -->
            <div class="company-header">
              <div class="company-info">
                <div class="company-logo">DEV</div>
                <div class="company-details">
                  ${companyInfo.name}<br>
                  ${companyInfo.address}<br>
                  Tél: ${companyInfo.phone}<br>
                  Email: ${companyInfo.email}
                </div>
              </div>
            </div>

            <!-- Invoice Title and Metadata -->
            <div class="invoice-title">
              FACTURE
            </div>
            <div class="invoice-metadata">
              Date: ${formatDate(factureData.date_facture)}<br>
              N° Facture: ${factureData.numero_facture}
            </div>

            <!-- Invoice Information Grid -->
            <div class="invoice-info-grid">
              <div class="info-column">
                <div class="info-group">
                  <div class="info-label">FACTURER À:</div>
                  <div class="info-value client-name">${factureData.client_nom}</div>
                  <div class="info-value">${factureData.client_adresse || ""}</div>
                  <div class="info-value">${factureData.client_telephone || ""}</div>
                </div>
              </div>
              <div class="info-column">
                <div class="info-group">
                  <div class="info-item">
                    <span class="info-label">MODE DE PAIEMENT:</span>
                    <span class="info-value">${factureData.type_paiement}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">STATUT:</span>
                    <span class="info-value">${factureData.statut_paiement}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Products Table -->
            <div class="section-title">DÉTAIL DES PRODUITS</div>
            <table>
              <thead>
                <tr>
                  <th>Produit</th>
                  <th style="text-align: right">Quantité</th>
                  <th style="text-align: right">Prix unitaire</th>
                  <th style="text-align: right">Montant</th>
                </tr>
              </thead>
              <tbody>
                ${details
                  .map(
                    (detail) => `
                  <tr>
                    <td>${detail.designation || "Product"}</td>
                    <td class="amount-cell">${detail.quantite}</td>
                    <td class="amount-cell">${parseFloat(detail.prix_facture_unitaire).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}</td>
                    <td class="amount-cell">${parseFloat(detail.montant_total).toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}</td>
                  </tr>
                `
                  )
                  .join("")}
                <tr class="total-row">
                  <td colspan="3">Montant Total</td>
                  <td class="amount-cell">${totalAmount.toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}</td>
                </tr>
              </tbody>
            </table>

            ${
              factureData.type_paiement === "Tranche"
                ? `
              <!-- Payment Terms -->
              <div class="section-title">CONDITIONS DE PAIEMENT</div>
              <div>Ce montant sera payé en plusieurs tranches selon l'échéancier convenu.</div>
            `
                : ""
            }

            <!-- Signatures Section -->
            <div class="signature-section">
              <div class="signature-box">
                <div class="signature-line"></div>
                <div class="signature-title">Client</div>
              </div>
              <div class="signature-box">
                <div class="signature-line"></div>
                <div class="signature-title">Vendeur</div>
              </div>
            </div>

            <!-- Footer -->
            <div class="footer">
              <div class="footer-text">
                Ce document est généré automatiquement et ne nécessite pas de signature électronique<br>
                ${companyInfo.name} • ${companyInfo.address} • Tél: ${companyInfo.phone}
              </div>
            </div>
          </div>
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="contained"
          startIcon={<PrintIcon />}
          onClick={handlePrint}
          color="secondary"
        >
          Imprimer
        </Button>
        <Button variant="outlined" startIcon={<CloseIcon />} onClick={onClose}>
          Fermer
        </Button>
      </Box>
    </Box>
  );
};

export default PrintFacture;
